import { TechnologyCharge, TechnologyChargeType } from "../../data-types";

export const getTechnologyChargeAmount = (
  technologyCharge: TechnologyCharge,
  legalFees: number
): number => {
  switch (technologyCharge.type) {
    case TechnologyChargeType.Fixed:
      return technologyCharge.fixedAmount;
    case TechnologyChargeType.Percentage:
      return (technologyCharge.percentage * legalFees) / 100;
    case TechnologyChargeType.BasePlusUnits:
      return technologyCharge.baseAmount + technologyCharge.units * technologyCharge.unitCost;
    default:
      return 0;
  }
};

export const sumTechnologyChargesSingle = (
  technologyCharges: TechnologyCharge[] | null,
  legalFees: number
): number => {
  if (!technologyCharges) return 0;

  return technologyCharges.reduce(
    (acc, technologyCharge) => acc + getTechnologyChargeAmount(technologyCharge, legalFees),
    0
  );
};

export const sumTechnologyChargesRange = (
  technologyCharges: TechnologyCharge[] | null,
  legalFees: { lower: number; upper: number }
): { lower: number; upper: number } => {
  if (!technologyCharges) return { lower: 0, upper: 0 };

  let lower = 0;
  let upper = 0;

  for (const charge of technologyCharges) {
    lower += getTechnologyChargeAmount(charge, legalFees.lower);
    upper += getTechnologyChargeAmount(charge, legalFees.upper);
  }

  return { lower, upper };
};
